import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import type {
  DataSource,
  DataSourceListResponse,
} from "@/types/referenceCompound";

/**
 * 데이터 출처 목록 조회 (GET /api/v1/data-sources)
 * API 실패 시 빈 배열 반환
 */
export function useDataSources() {
  return useQuery<DataSource[]>({
    queryKey: ["data-sources"],
    queryFn: async () => {
      const res = await api.get<DataSourceListResponse>("/data-sources");
      return res.data.items;
    },
    staleTime: 5 * 60 * 1000,
    // API 실패 시 빈 배열 fallback
    placeholderData: [],
  });
}
